import { AnalyticsCart } from './Analytics.Cart'

export const Analytics = {
  Cart: AnalyticsCart,
}
